import { gql } from "@apollo/client";

export const GET_BUSINESS_RECOMMENDATION_ACTIVITIES = gql`
  query getBusinessRecommendationActivities(
    $filter: UserFilterInputType
    $activityfilter: FieldFilterInputType
    $pagination: PaginationInputType
  ) {
    getBusinessRecommendationActivities(filter: $filter, activityfilter: $activityfilter, pagination: $pagination) {
      businessRecommendationActivities {
        firstName
        lastName
        username
        regionCity
        regionState
        regionCountry
      }
      total
    }
  }
`;